import { SxProps, Theme } from "@mui/system";

export const mainLayoutBox: SxProps<Theme> = {
  padding: "40px 81px",
};

export const invoiceLayoutBox: SxProps<Theme> = {
  display: "flex",
  flexDirection: "row",
  gap: "30px",
};

export const invoiceBox: SxProps<Theme> = {
  // maxWidth: "700px",
  width: "100%",
};

export const titleTypography: SxProps<Theme> = {
  fontWeight: "500",
  marginBottom: "44px",
  fontSize: "20px",
};

export const borderBox: SxProps<Theme> = {
  border: "3px solid black",
};

export const updateButtonBox: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  paddingTop: "85px",
  paddingBottom: "140px",
};

export const updateButton: SxProps<Theme> = {
  backgroundColor: "#333333",
  width: "300px",
  height: "48px",
  padding: "9px",
  borderRadius: "16px",
  fontWeight: "600",
  fontSize: "14px",
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#555555",
  },
};
export const downloadButton: SxProps<Theme> = {
  display: "flex",
  justifyContent: "space-between",
  gap: "20px",
};
